var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntdesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "62.102327%",
    x2: "108.19718%",
    y1: "0%",
    y2: "37.863576%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ec7ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "69.644116%",
    x2: "54.042898%",
    y1: "0%",
    y2: "108.456714%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29cdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378600687,
    stopColor: "#148eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a60ff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "69.690817%",
    x2: "16.722898%",
    y1: "-12.974359%",
    y2: "117.391248%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa816e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41472606,
    stopColor: "#f74a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f51d2c"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "68.127987%",
    x2: "30.440091%",
    y1: "-35.690574%",
    y2: "114.942679%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8e7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512635191,
    stopColor: "#f74a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f51d2c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116.850078 4.54548777-112.32114907 112.22878723c-6.03857191 6.033606-6.03857191 15.778899 0 21.812506l112.32114907 112.228787c6.038572 6.033607 15.791886 6.033607 21.830458 0l47.094654-47.055927c5.407982-5.403535 5.407982-14.164396 0-19.56793-5.407982-5.403536-14.176054-5.403536-19.584036 0l-35.702079 35.672721c-1.502991 1.501755-3.784086 1.501755-5.287077 0l-89.6964602-89.622703c-1.5029909-1.501755-1.5029909-3.780974 0-5.282729l89.6964602-89.6227024c1.502991-1.5017551 3.784086-1.5017551 5.287077 0l35.702079 35.6727214c5.407982 5.4035349 14.176054 5.4035349 19.584036 0 5.407982-5.403535 5.407982-14.1643962 0-19.5679311l-47.089463-47.05080777c-6.063366-5.90303668-15.820247-5.85524816-21.835649.15520764z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.850078 4.54548777-112.32114907 112.22878723c-6.03857191 6.033606-6.03857191 15.778899 0 21.812506l112.32114907 112.228787c6.038572 6.033607 15.791886 6.033607 21.830458 0l47.094654-47.055927c5.407982-5.403535 5.407982-14.164396 0-19.56793-5.407982-5.403536-14.176054-5.403536-19.584036 0l-35.702079 35.672721c-1.502991 1.501755-3.784086 1.501755-5.287077 0l-89.6964602-89.622703c-1.5029909-1.501755-1.5029909-3.780974 0-5.282729l89.6964602-89.6227024c3.742399-3.2262971 9.848527-9.7610839 18.815407-11.2894545 6.664025-1.1358578 13.949616 1.364145 21.856772 7.5000089-5.28643-5.2820901-14.349247-14.3342807-27.18845-27.15657187-6.063366-5.90303668-15.820247-5.85524816-21.835649.15520764z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.646643 173.754365c5.407982 5.403534 14.176053 5.403534 19.584034 0l34.739327-34.710761c6.038572-6.033606 6.038572-15.7789.000707-21.811803l-35.042164-34.889186c-5.420784-5.397121-14.191639-5.389338-19.602822.0173949-5.407982 5.403535-5.407982 14.1643961 0 19.5679311l23.667671 23.648209c1.502991 1.501755 1.502991 3.780974 0 5.282729l-23.346753 23.327554c-5.407983 5.403535-5.407983 14.164396 0 19.567932z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.326913,
    cy: 128.241672,
    fill: "url(#d)",
    rx: 30.32671,
    ry: 30.301772
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntdesign);
export default __webpack_public_path__ + "static/media/antdesign.0aa992f997421683296276fa7b256e94.svg";
export { ForwardRef as ReactComponent };